import React, { useState } from 'react';
import OrderUpdate from './Order_Update';
import BatchUpdate from './Batch_Update';

const UpdateOrderDueDate = () => {
  // State to track which tab is active
  const [activeTab, setActiveTab] = useState('order-update');

  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-sm flex flex-col h-[calc(100vh-120px)]">
      {/* Tab Navigation */}
      <div className="px-6 pt-6 border-b border-slate-700">
        <div className="flex space-x-1">
          <button
            onClick={() => setActiveTab('order-update')}
            className={`px-4 py-2 rounded-t-lg font-medium text-sm transition-colors ${
              activeTab === 'order-update' 
                ? 'bg-slate-700 text-white border-b-2 border-blue-500' 
                : 'text-slate-400 hover:text-slate-300 hover:bg-slate-700/50'
            }`}
          >
            Order Update
          </button>
          <button
            onClick={() => setActiveTab('batch-update')}
            className={`px-4 py-2 rounded-t-lg font-medium text-sm transition-colors ${
              activeTab === 'batch-update' 
                ? 'bg-slate-700 text-white border-b-2 border-blue-500' 
                : 'text-slate-400 hover:text-slate-300 hover:bg-slate-700/50'
            }`}
          >
            Batch Update
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'order-update' ? (
          <OrderUpdate />
        ) : (
          <BatchUpdate />
        )}
      </div>
    </div>
  );
};

export default UpdateOrderDueDate;
